var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-container display-center-center"},[_c('ul',{staticClass:"footer-wrap"},[_c('li',[_vm._v(" Address：Hunan Changsha Xiangyu International Center / support@pzmobile.com / ")]),_c('li',[_vm._v("Copyright © 2024")])])])
}]

export { render, staticRenderFns }